'use client';
import { _ as _slicedToArray } from './slicedToArray-7f123e5d.esm.js';
import _styled from '@emotion/styled/base';
import { Progress } from '@cue/atoms';
import { useState, useEffect } from 'react';
import { jsx } from '@emotion/react';

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var VideoProgressBar = function VideoProgressBar(_ref) {
  var current = _ref.current,
    total = _ref.total,
    loaded = _ref.loaded,
    onSeek = _ref.onSeek;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    percent = _useState2[0],
    setPercent = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    setBuffered = _useState4[1];
  useEffect(function () {
    if (current && total) setPercent(current / total);
    if (current && loaded) setBuffered(current / loaded);
  }, [current, total]);
  return jsx(VideoProgressBarContainer, {
    className: "cue-video-ui-ctrl-progress"
  }, jsx(Progress, {
    className: "cue-video-ui-ctrl-progress-bar",
    value: percent,
    styling: "videoProgress",
    onChange: function onChange(val) {
      return onSeek && total && onSeek(total * val);
    }
  }));
};
var VideoProgressBarContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "evz5a4x0"
} : {
  target: "evz5a4x0",
  label: "VideoProgressBarContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : {
  name: "1d3w5wq",
  styles: "width:100%",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInZpZGVvLXByb2dyZXNzLWJhci50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBcUM0QyIsImZpbGUiOiJ2aWRlby1wcm9ncmVzcy1iYXIudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiXG5pbXBvcnQgeyBWaWRlb1RpbWVQcm9wcyB9IGZyb20gJy4vdmlkZW8tdGltZSc7XG5pbXBvcnQgeyBQcm9ncmVzcyB9IGZyb20gJ0BjdWUvYXRvbXMnO1xuaW1wb3J0IHsgU3R5bGVkQ29tcG9uZW50IH0gZnJvbSAnQGN1ZS90aGVtZSc7XG5pbXBvcnQgc3R5bGVkLCB7IENTU09iamVjdCB9IGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgUmVhY3QsIHsgdXNlRWZmZWN0LCB1c2VTdGF0ZSB9IGZyb20gJ3JlYWN0JztcblxuZXhwb3J0IGNvbnN0IFZpZGVvUHJvZ3Jlc3NCYXI6IFJlYWN0LkZDPFxuICBWaWRlb1Byb2dyZXNzQmFyUHJvcHMgJiBTdHlsZWRDb21wb25lbnQ8VmlkZW9Qcm9ncmVzc0NTU092ZXJyaWRlPlxuPiA9ICh7IGN1cnJlbnQsIHRvdGFsLCBsb2FkZWQsIG9uU2VlayB9KSA9PiB7XG4gIGNvbnN0IFtwZXJjZW50LCBzZXRQZXJjZW50XSA9IHVzZVN0YXRlKDApO1xuICBjb25zdCBbLCBzZXRCdWZmZXJlZF0gPSB1c2VTdGF0ZSgwKTtcblxuICB1c2VFZmZlY3QoKCkgPT4ge1xuICAgIGlmIChjdXJyZW50ICYmIHRvdGFsKSBzZXRQZXJjZW50KGN1cnJlbnQgLyB0b3RhbCk7XG4gICAgaWYgKGN1cnJlbnQgJiYgbG9hZGVkKSBzZXRCdWZmZXJlZChjdXJyZW50IC8gbG9hZGVkKTtcbiAgfSwgW2N1cnJlbnQsIHRvdGFsXSk7XG4gIHJldHVybiAoXG4gICAgPFZpZGVvUHJvZ3Jlc3NCYXJDb250YWluZXIgY2xhc3NOYW1lPVwiY3VlLXZpZGVvLXVpLWN0cmwtcHJvZ3Jlc3NcIj5cbiAgICAgIDxQcm9ncmVzc1xuICAgICAgICBjbGFzc05hbWU9XCJjdWUtdmlkZW8tdWktY3RybC1wcm9ncmVzcy1iYXJcIlxuICAgICAgICB2YWx1ZT17cGVyY2VudH1cbiAgICAgICAgc3R5bGluZz1cInZpZGVvUHJvZ3Jlc3NcIlxuICAgICAgICBvbkNoYW5nZT17KHZhbDogbnVtYmVyKSA9PiBvblNlZWsgJiYgdG90YWwgJiYgb25TZWVrKHRvdGFsICogdmFsKX1cbiAgICAgIC8+XG4gICAgPC9WaWRlb1Byb2dyZXNzQmFyQ29udGFpbmVyPlxuICApO1xufTtcbmV4cG9ydCBpbnRlcmZhY2UgVmlkZW9Qcm9ncmVzc0JhclByb3BzIGV4dGVuZHMgVmlkZW9UaW1lUHJvcHMge1xuICBsb2FkZWQ/OiBudW1iZXI7XG4gIG9uU2Vlaz8odGltZTogbnVtYmVyKTogdm9pZDtcbn1cblxuZXhwb3J0IHR5cGUgVmlkZW9Qcm9ncmVzc0NTU092ZXJyaWRlID0ge1xuICAnLmN1ZS12aWRlby11aS1jdHJsLXByb2dyZXNzJz86IENTU09iamVjdDtcbiAgJy5jdWUtdmlkZW8tdWktY3RybC1wcm9ncmVzcy1iYXInPzogQ1NTT2JqZWN0O1xufTtcbmNvbnN0IFZpZGVvUHJvZ3Jlc3NCYXJDb250YWluZXIgPSBzdHlsZWQuZGl2YFxuICB3aWR0aDogMTAwJTtcbmA7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

export { VideoProgressBar };
